export function ProductPage() {
  return (
    <section className="page band" id="product" data-testid="dp-page-product">
      <div className="wrap">
        <div className="head">
          <div className="eyebrow">Product architecture</div>
          <h2>One connected system. Adopt what your team needs.</h2>
          <p>
            Zephix is being designed around a shared project record so accountability, approvals,
            risk, and reporting stay connected.
          </p>
        </div>
        <div className="moduleGrid">
          <article className="module wide">
            <div className="icon">◎</div>
            <h3>Work management core</h3>
            <p>
              Projects, tasks, milestones, ownership, status, and the work structure that every other
              capability connects to.
            </p>
            <span className="state">Core launch capability</span>
          </article>
          <article className="module">
            <div className="icon">✓</div>
            <h3>Governance &amp; approvals</h3>
            <p>Project checkpoints, evidence requirements, approval chains, and visible decisions.</p>
            <span className="state">Pilot focus</span>
          </article>
          <article className="module">
            <div className="icon">!</div>
            <h3>Risk &amp; issues</h3>
            <p>Capture risk, mitigation ownership, and issues in the context of active work.</p>
            <span className="state">Pilot focus</span>
          </article>
          <article className="module">
            <div className="icon">↗</div>
            <h3>Portfolio visibility</h3>
            <p>Leadership views that evolve from real design-partner reporting needs.</p>
            <span className="state future">Expansion area</span>
          </article>
          <article className="module">
            <div className="icon">⌁</div>
            <h3>Capacity &amp; financial controls</h3>
            <p>
              Introduced only after the core governed workflow is proven in real organizations.
            </p>
            <span className="state future">Future capability</span>
          </article>
        </div>
      </div>
    </section>
  );
}
